// ==========================================================
// window.DDCore — 配送日時指定の共通ロジック
// カートページ版(delivery-date-time.js)とドロワー版
// (delivery-date-time-drawer.js)の両方がこれを参照します。
// 業務ルール（定休日・カットオフ・都道府県別リードタイムなど）は
// ここに集約しています。値を変える場合はこのファイルだけ直せば
// 両方に反映されます。
// ==========================================================
(function () {
  'use strict';

  // ---------- 運用ルール（ここを直せば両方に反映されます） ----------
  var CLOSED_WEEKDAYS = [0, 1, 6]; // 0=日,1=月,2=火,3=水,4=木,5=金,6=土 → 日・月・土定休
  var CUTOFF_HOUR = 14;
  var CUTOFF_MINUTE = 0;
  var WINDOW_DAYS = 7;
  var EXCLUDE_HOLIDAYS = true;
  var FALLBACK_LEAD_DAYS = 1;

  // 単発の追加休業日・毎年繰り返す休業期間は、非エンジニアでも編集しやすい
  // ように assets/delivery-date-time-holidays.txt という専用のテキスト
  // ファイルに分離しました。このファイルはページ読み込み時に取得します。
  var extraClosedSet = {};
  var recurringRanges = [];
  var readyResolve;
  var ready = new Promise(function (resolve) { readyResolve = resolve; });

  function parseHolidaysText(text) {
    text.split('\n').forEach(function (line) {
      line = line.trim();
      if (!line || line.charAt(0) === '#') return;
      var m = line.match(/^([a-z_]+)\s*:\s*(.*)$/i);
      if (!m) return;
      var key = m[1].trim();
      var value = m[2].trim();
      if (!value) return;

      if (key === 'extra_closed_dates') {
        value.split(',').forEach(function (s) {
          s = s.trim();
          if (/^\d{4}-\d{2}-\d{2}$/.test(s)) extraClosedSet[s] = true;
        });
      } else if (key === 'recurring_closed_ranges') {
        value.split(',').forEach(function (s) {
          s = s.trim();
          var rm = s.match(/^(\d{2})-(\d{2}):(\d{2})-(\d{2})$/);
          if (rm) recurringRanges.push({ sm: +rm[1], sd: +rm[2], em: +rm[3], ed: +rm[4] });
        });
      }
    });
  }

  function loadHolidaysText() {
    var url = window.__ddHolidaysUrl;
    if (!url) { readyResolve(); return; }
    fetch(url)
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (text) { parseHolidaysText(text); readyResolve(); })
      .catch(function () { readyResolve(); }); // 読み込めなくても致命的にはしない（休業日なしとして継続）
  }
  loadHolidaysText();

  // ---------- 都道府県 → リードタイム(日) 対応表（2026-08-07 確定） ----------
  var PREFECTURE_LEAD_DAYS = {
    '北海道': 3,

    '青森県': 1, '岩手県': 1, '宮城県': 1, '秋田県': 1, '山形県': 1, '福島県': 1, // 東北

    '茨城県': 1, '栃木県': 1, '群馬県': 1, '埼玉県': 1, '千葉県': 1, '東京都': 1, '神奈川県': 1, '山梨県': 1, // 関東
    '新潟県': 1, '長野県': 1, // 信越
    '富山県': 1, '石川県': 1, '福井県': 1, // 北陸
    '岐阜県': 1, '静岡県': 1, '愛知県': 1, '三重県': 1, // 中部
    '滋賀県': 1, '京都府': 1, '大阪府': 1, '兵庫県': 1, '奈良県': 1, '和歌山県': 1, // 関西

    '鳥取県': 2, '島根県': 2, '岡山県': 2, '広島県': 2, '山口県': 2, // 中国
    '徳島県': 2, '香川県': 2, '愛媛県': 2, '高知県': 2, // 四国
    '福岡県': 2, '佐賀県': 2, '長崎県': 2, '熊本県': 2, '大分県': 2, '宮崎県': 2, '鹿児島県': 2, // 九州

    '沖縄県': 3 // 沖縄
  };

  var PREFECTURE_GROUPS = [
    ['北海道', ['北海道']],
    ['東北', ['青森県', '岩手県', '宮城県', '秋田県', '山形県', '福島県']],
    ['関東', ['茨城県', '栃木県', '群馬県', '埼玉県', '千葉県', '東京都', '神奈川県', '山梨県']],
    ['信越', ['新潟県', '長野県']],
    ['北陸', ['富山県', '石川県', '福井県']],
    ['中部', ['岐阜県', '静岡県', '愛知県', '三重県']],
    ['関西', ['滋賀県', '京都府', '大阪府', '兵庫県', '奈良県', '和歌山県']],
    ['中国', ['鳥取県', '島根県', '岡山県', '広島県', '山口県']],
    ['四国', ['徳島県', '香川県', '愛媛県', '高知県']],
    ['九州', ['福岡県', '佐賀県', '長崎県', '熊本県', '大分県', '宮崎県', '鹿児島県']],
    ['沖縄', ['沖縄県']]
  ];

  var WEEKDAY_LABEL = ['日', '月', '火', '水', '木', '金', '土'];

  // ---------- 日付ユーティリティ（UTC日付演算） ----------
  function dutc(y, m, d) { return new Date(Date.UTC(y, m - 1, d)); }
  function addDaysUTC(d, n) { return new Date(d.getTime() + n * 86400000); }
  function iso(d) {
    return d.getUTCFullYear() + '-' + String(d.getUTCMonth() + 1).padStart(2, '0') + '-' + String(d.getUTCDate()).padStart(2, '0');
  }
  function slash(d) {
    return d.getUTCFullYear() + '/' + String(d.getUTCMonth() + 1).padStart(2, '0') + '/' + String(d.getUTCDate()).padStart(2, '0');
  }

  // ---------- 日本の祝日計算 ----------
  // 固定日・第n月曜日は法律どおり計算されるため将来も正確です。
  // 春分の日・秋分の日は天文計算の近似式（2099年まで有効とされる式）を
  // 使用しているため、国立天文台の実際の官報発表とは理論上わずかに
  // ズレる可能性があります。天皇誕生日(2/23)も代替わりがあれば変わります。
  function nthMonday(year, month, n) {
    var day1 = dutc(year, month, 1);
    var offset = (1 - day1.getUTCDay() + 7) % 7;
    return addDaysUTC(addDaysUTC(day1, offset), (n - 1) * 7);
  }
  function vernalEquinox(year) {
    var day = Math.floor(20.8431 + 0.242194 * (year - 1980)) - Math.floor((year - 1980) / 4);
    return dutc(year, 3, day);
  }
  function autumnalEquinox(year) {
    var day = Math.floor(23.2488 + 0.242194 * (year - 1980)) - Math.floor((year - 1980) / 4);
    return dutc(year, 9, day);
  }
  function baseHolidaysForYear(year) {
    var h = {};
    h[iso(dutc(year, 1, 1))] = '元日';
    h[iso(nthMonday(year, 1, 2))] = '成人の日';
    h[iso(dutc(year, 2, 11))] = '建国記念の日';
    h[iso(dutc(year, 2, 23))] = '天皇誕生日';
    h[iso(vernalEquinox(year))] = '春分の日';
    h[iso(dutc(year, 4, 29))] = '昭和の日';
    h[iso(dutc(year, 5, 3))] = '憲法記念日';
    h[iso(dutc(year, 5, 4))] = 'みどりの日';
    h[iso(dutc(year, 5, 5))] = 'こどもの日';
    h[iso(nthMonday(year, 7, 3))] = '海の日';
    h[iso(dutc(year, 8, 11))] = '山の日';
    h[iso(nthMonday(year, 9, 3))] = '敬老の日';
    h[iso(autumnalEquinox(year))] = '秋分の日';
    h[iso(nthMonday(year, 10, 2))] = 'スポーツの日';
    h[iso(dutc(year, 11, 3))] = '文化の日';
    h[iso(dutc(year, 11, 23))] = '勤労感謝の日';
    return h;
  }
  var holidayCache = {};
  function holidaysAroundYear(year) {
    if (holidayCache[year]) return holidayCache[year];
    var h = {};
    [year - 1, year, year + 1].forEach(function (y) { Object.assign(h, baseHolidaysForYear(y)); });

    var substitutes = {};
    Object.keys(h).forEach(function (key) {
      var d = new Date(key + 'T00:00:00Z');
      if (d.getUTCDay() === 0) {
        var nd = addDaysUTC(d, 1);
        while (h[iso(nd)] || substitutes[iso(nd)]) nd = addDaysUTC(nd, 1);
        substitutes[iso(nd)] = '振替休日';
      }
    });
    Object.assign(h, substitutes);

    var sandwich = {};
    Object.keys(h).forEach(function (key) {
      var d = new Date(key + 'T00:00:00Z');
      var mid = addDaysUTC(d, 1);
      var next = addDaysUTC(d, 2);
      if (h[iso(next)] && !h[iso(mid)] && mid.getUTCDay() !== 0) sandwich[iso(mid)] = '国民の休日';
    });
    Object.assign(h, sandwich);

    holidayCache[year] = h;
    return h;
  }
  function isJapaneseHoliday(d) {
    return !!holidaysAroundYear(d.getUTCFullYear())[iso(d)];
  }

  function isInRecurringRange(d) {
    var m = d.getUTCMonth() + 1, day = d.getUTCDate();
    return recurringRanges.some(function (r) {
      var val = m * 100 + day, start = r.sm * 100 + r.sd, end = r.em * 100 + r.ed;
      return start <= end ? (val >= start && val <= end) : (val >= start || val <= end);
    });
  }

  function isClosedDate(d) {
    if (CLOSED_WEEKDAYS.indexOf(d.getUTCDay()) !== -1) return true;
    if (EXCLUDE_HOLIDAYS && isJapaneseHoliday(d)) return true;
    if (extraClosedSet[iso(d)]) return true;
    if (isInRecurringRange(d)) return true;
    return false;
  }

  // ---------- JST基準の「現在時刻」（訪問者の端末のタイムゾーンに依存しない） ----------
  function getJSTNow() {
    var parts = new Intl.DateTimeFormat('en-US', {
      timeZone: 'Asia/Tokyo', year: 'numeric', month: '2-digit', day: '2-digit',
      hour: '2-digit', minute: '2-digit', hour12: false
    }).formatToParts(new Date());
    var map = {};
    parts.forEach(function (p) { map[p.type] = p.value; });
    var hour = parseInt(map.hour, 10);
    if (hour === 24) hour = 0;
    return { today: dutc(+map.year, +map.month, +map.day), hour: hour, minute: parseInt(map.minute, 10) };
  }

  function currentLeadDaysFor(pref) {
    if (pref && PREFECTURE_LEAD_DAYS.hasOwnProperty(pref)) return PREFECTURE_LEAD_DAYS[pref];
    return FALLBACK_LEAD_DAYS;
  }

  // 定休日・祝日は「出荷できるかどうか」にのみ影響します。
  // 一度出荷されれば配送業者は土日祝も配達するため、お届け日の候補には
  // 曜日・祝日によるフィルタは一切かけません。
  //
  // 手順:
  //  1) 注文日"自体"が出荷休業日の場合のみ、直近の出荷可能日まで前進
  //     （営業日の注文ならそのまま。cf. カットオフ時刻も考慮済み）
  //  2) 最短出荷日 + リードタイム = 最短お届け日
  //  3) 最短お届け日から暦通りwindowDays日間をそのまま候補にする
  //     （土日祝を含め、除外・スキップは行わない）
  function buildCandidates(leadDays, windowDays) {
    windowDays = windowDays || WINDOW_DAYS;
    var now = getJSTNow();
    var pastCutoff = (now.hour > CUTOFF_HOUR) || (now.hour === CUTOFF_HOUR && now.minute >= CUTOFF_MINUTE);
    var orderDate = pastCutoff ? addDaysUTC(now.today, 1) : now.today;

    var effectiveShipDate = orderDate;
    var guard = 0;
    while (isClosedDate(effectiveShipDate) && guard < 90) {
      effectiveShipDate = addDaysUTC(effectiveShipDate, 1);
      guard++;
    }

    var earliestDelivery = addDaysUTC(effectiveShipDate, leadDays);

    var list = [];
    for (var i = 0; i < windowDays; i++) {
      list.push({ date: addDaysUTC(earliestDelivery, i), closed: false });
    }
    return list;
  }

  // ---------- カート保存 ----------
  function currentCartAttributes() {
    return fetch('/cart.js').then(function (r) { return r.json(); })
      .then(function (c) { return c || {}; })
      .catch(function () { return { attributes: {} }; });
  }

  function saveToCart(newAttrs) {
    return currentCartAttributes().then(function (cart) {
      var merged = Object.assign({}, cart.attributes || {}, newAttrs);
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ attributes: merged })
      });
    });
  }

  // ---------- 日時指定を非表示にする条件 ----------
  // 以下のいずれかに該当する商品がカートにある場合、ウィジェットを表示しない。
  //   ・タグに「ネコポス」を含む
  //   ・タグに「配送日付指定対象外」を含む
  //   ・重量が101g以上（=100g以下のみ日時指定可）
  // カートページ側(delivery-date-time.liquid)ではセクション設定
  // (hide_tags)でタグの既定値を、テンプレート内で重量の閾値を管理して
  // います。両方を変える場合は両方直してください。
  var HIDE_TAGS = ['ネコポス', '配送日付指定対象外'];
  var MAX_ALLOWED_WEIGHT_GRAMS = 100; // これを超える(101g以上)と非表示

  // /cart.js の line item には商品タグが含まれないため、
  // 各商品を /products/{handle}.js で個別に取得してタグと該当バリアントの
  // 重量(グラム)を判定する
  function cartIsIneligibleForDelivery() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = cart.items || [];
        if (!items.length) return false;
        return Promise.all(items.map(function (item) {
          if (!item.handle) return false;
          return fetch('/products/' + item.handle + '.js')
            .then(function (r) { return r.ok ? r.json() : null; })
            .then(function (product) {
              if (!product) return false;
              var tags = product.tags || [];
              if (HIDE_TAGS.some(function (tag) { return tags.indexOf(tag) !== -1; })) return true;

              var variant = (product.variants || []).filter(function (v) { return v.id === item.variant_id; })[0];
              var grams = variant ? variant.grams : null;
              if (typeof grams === 'number' && grams > MAX_ALLOWED_WEIGHT_GRAMS) return true;

              return false;
            })
            .catch(function () { return false; });
        })).then(function (results) {
          return results.some(function (r) { return r; });
        });
      })
      .catch(function () { return false; });
  }

  window.DDCore = {
    ready: ready,
    HIDE_TAGS: HIDE_TAGS,
    PREFECTURE_LEAD_DAYS: PREFECTURE_LEAD_DAYS,
    PREFECTURE_GROUPS: PREFECTURE_GROUPS,
    WEEKDAY_LABEL: WEEKDAY_LABEL,
    dutc: dutc,
    addDaysUTC: addDaysUTC,
    iso: iso,
    slash: slash,
    isClosedDate: isClosedDate,
    getJSTNow: getJSTNow,
    currentLeadDaysFor: currentLeadDaysFor,
    buildCandidates: buildCandidates,
    currentCartAttributes: currentCartAttributes,
    cartIsIneligibleForDelivery: cartIsIneligibleForDelivery,
    saveToCart: saveToCart
  };
})();